import React, { useState, useRef } from "react";
import "../Contracting/Contracting.css"; // Custom CSS for styling the form
import logoSrc from "../img/logo.png";
import ContactForm from "../ContactForm"; // Make sure this component has the `openForm` method.

const EducationForm = () => {
  const contactFormRef = useRef(); // Reference for controlling the contact form
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    countryRegion: "",
    preferredTrainingProgram: "",
    whyInterested: "",
    previousExperience: "",
    educationLevel: "",
    availability: "",
    learningStyle: "",
    howDidYouHear: "",
    supportingDocuments: null,
    questionsComments: "",
  });
  const [snackbar, setSnackbar] = useState({
    message: "",
    show: false,
    type: "success",
  });

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.type === "application/pdf") {
        setFormData({ ...formData, supportingDocuments: file });
      } else {
        setFormData({ ...formData, supportingDocuments: file });
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("firstName", formData.firstName);
    formDataToSubmit.append("lastName", formData.lastName);
    formDataToSubmit.append("email", formData.email);
    formDataToSubmit.append("phone", formData.phone);
    formDataToSubmit.append("countryRegion", formData.countryRegion);
    formDataToSubmit.append(
      "preferredTrainingProgram",
      formData.preferredTrainingProgram
    );
    formDataToSubmit.append("whyInterested", formData.whyInterested);
    formDataToSubmit.append("previousExperience", formData.previousExperience);
    formDataToSubmit.append("educationLevel", formData.educationLevel);
    formDataToSubmit.append("availability", formData.availability);
    formDataToSubmit.append("learningStyle", formData.learningStyle);
    formDataToSubmit.append("howDidYouHear", formData.howDidYouHear);
    formDataToSubmit.append("questionsComments", formData.questionsComments);

    if (formData.supportingDocuments) {
      formDataToSubmit.append(
        "supportingDocuments",
        formData.supportingDocuments
      );
    }

    try {
      const response = await fetch(
        "https://apiqms.shigjeta.com/api/forms/education/submit",
        {
          method: "POST",
          body: formDataToSubmit,
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error response:", response.status, errorText);
        throw new Error(
          `Form submission failed with status ${response.status}`
        );
      }

      const data = await response.json();
      console.log("Form submitted successfully:", data);
      // Show success snackbar
      setSnackbar({
        message: "Form submitted successfully!",
        show: true,
        type: "success",
      });
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Show error snackbar
      setSnackbar({
        message: "There was an error submitting your form. Please try again.",
        show: true,
        type: "error",
      });
    }
  };

  // Snackbar styling
  const snackbarStyle = {
    position: "fixed",
    top: "20px", // Move it to the top
    left: "50%", // Center horizontally
    transform: "translateX(-50%)", // Adjust to perfectly center
    backgroundColor: snackbar.type === "success" ? "#16a085" : "#e74c3c", // Green for success, red for error
    color: "white",
    padding: "15px 30px",
    borderRadius: "8px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1001,
    animation: "fadeIn 0.5s ease-out",
  };

  const dismissButtonStyle = {
    background: "none",
    border: "none",
    color: "white",
    fontSize: "16px",
    cursor: "none",
    fontWeight: "bold",
    marginLeft: "15px", // Adds a gap between the text and the button
  };

  // Close snackbar after 5 seconds
  setTimeout(() => {
    if (snackbar.show) {
      setSnackbar({ ...snackbar, show: false });
    }
  }, 5000);

  return (
    <>
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjetademy Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">Shigjetademy education form</h1>
            <p className="banner-description">
              Apply for Shigjetademy's training programs today!
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>

      <div className="img-background">
        <img
          className="img"
          id="banner1-video"
          src="/img/Education Thumbnail.png" // This should be correct if the video is in the public folder
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error("Error loading video:", e)} // Error logging for debugging
        />
      </div>

      <h3 className="textForm">Shigjeta LLC - Education Form</h3>

      {/* Form Section */}
      <section className="contract-form-container">
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="divFlexField">
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter your first name"
                required
              />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="countryRegion">Country/Region</label>
            <input
              type="text"
              id="countryRegion"
              name="countryRegion"
              value={formData.countryRegion}
              onChange={handleChange}
              placeholder="Enter your country/region"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="preferredTrainingProgram">
              Preferred Training Program
            </label>
            <select
              id="preferredTrainingProgram"
              name="preferredTrainingProgram"
              value={formData.preferredTrainingProgram}
              onChange={handleChange}
              required
            >
              <option value="Graphic Design">Graphic Design</option>
              <option value="Digital Marketing">Digital Marketing</option>
              <option value="Artificial Intelligence">
                Artificial Intelligence
              </option>
              <option value="Photography and Videography">
                Photography and Videography
              </option>
              <option value="Programming">Programming</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="whyInterested">
              Why Are You Interested in This Program?
            </label>
            <textarea
              id="whyInterested"
              name="whyInterested"
              value={formData.whyInterested}
              onChange={handleChange}
              placeholder="Describe why you are interested in this program"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="previousExperience">
              Previous Experience in This Field (Optional)
            </label>
            <textarea
              id="previousExperience"
              name="previousExperience"
              value={formData.previousExperience}
              onChange={handleChange}
              placeholder="Describe your previous experience (if any)"
            />
          </div>

          <div className="form-group">
            <label htmlFor="educationLevel">Education Level</label>
            <input
              type="text"
              id="educationLevel"
              name="educationLevel"
              value={formData.educationLevel}
              onChange={handleChange}
              placeholder="Enter your education level"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="availability">Availability</label>
            <input
              type="text"
              id="availability"
              name="availability"
              value={formData.availability}
              onChange={handleChange}
              placeholder="Enter your availability"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="learningStyle">Preferred Learning Style</label>
            <select
              id="learningStyle"
              name="learningStyle"
              value={formData.learningStyle}
              onChange={handleChange}
              required
            >
              <option value="Visual">Visual</option>
              <option value="Auditory">Auditory</option>
              <option value="Kinesthetic">Kinesthetic</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="howDidYouHear">How Did You Hear About Us?</label>
            <input
              type="text"
              id="howDidYouHear"
              name="howDidYouHear"
              value={formData.howDidYouHear}
              onChange={handleChange}
              placeholder="How did you hear about us?"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="supportingDocuments">
              Supporting Documents (Optional)
            </label>
            <input
              type="file"
              id="supportingDocuments"
              name="supportingDocuments"
              accept="application/pdf,image/*"
              onChange={handleFileChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="questionsComments">Questions/Comments</label>
            <textarea
              id="questionsComments"
              name="questionsComments"
              value={formData.questionsComments}
              onChange={handleChange}
              placeholder="Any questions or comments?"
            />
          </div>

          <button type="submit" className="submit-button">
            Submit Application
          </button>
        </form>
      </section>

      {/* Snackbar display */}
      {snackbar.show && (
        <div style={snackbarStyle}>
          <span>{snackbar.message}</span>
          <button
            onClick={() => setSnackbar({ ...snackbar, show: false })}
            style={dismissButtonStyle}
          >
            X
          </button>
        </div>
      )}

      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default EducationForm;
